import React, { Component } from 'react';
import { Image, Label, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import Moment from 'moment';

const TIMER_TO_REFRESH_NOTIFICATIONS_MIN = 1;
const TIMER_TO_REFRESH_NOTIFICATIONS_MS = TIMER_TO_REFRESH_NOTIFICATIONS_MIN * 60 * 1000;

class NavTopbar extends Component {
    componentDidMount() {
        console.log('NavTopbar mounted');
        this.props.getUserNotifications(this.props.user.accessToken);
        this.timer = setInterval(() => this.props.getUserNotifications(this.props.user.accessToken), TIMER_TO_REFRESH_NOTIFICATIONS_MS);
    }
    componentWillUnmount() {
        console.log('NavTopbar UN-mounted');
        clearInterval(this.timer);
    }
    render() {
        const lastLoginDate = (this.props.user) ? this.props.user.lastLogin : new Date();
        // bell slash outline
        // bell outline
        // bell slash
        // bell
        const bellDisplayIcon = (this.props.userHasUnreadMessages === true) ? 'bell' : 'bell outline';
        return (
            <div style={{float: 'right', marginRight: 10}}>
                <div style={{display: 'inline-block', padding: 10}}>
                    Last Login : { Moment(lastLoginDate).format('DD MMM YYYY HH:MM:SS') }
                </div>
                <div style={{display: 'inline-block', padding: 10}}>
                    <Link to="/app/profile?show=notifications">
                        <Label>
                            <Icon name={bellDisplayIcon} size="big" color="orange" />
                        </Label>
                    </Link>
                </div>
                <div style={{display: 'inline-block', padding: 10}}>
                    <Label style={{textTransform: 'capitalize'}}>
                        <Image avatar spaced='right' src={this.props.profilePhoto} />
                        { (this.props.user) ? this.props.user.name : '' }
                    </Label>
                </div>
            </div>
        );
    }
}

export default NavTopbar;
